<template>
  <key-unit class="editor-info-editable-item" :title="title">
    <template v-slot:content>
      <div>
        <el-input placeholder="请输入" v-model="value" :maxlength="50" :disabled="disabled">
        </el-input>
      </div>
    </template>
  </key-unit>
</template>

<script>
import KeyUnit from "@c/report-detail/single-blood-oxygen-report/common/new-key-unit/key-unit.vue";
export default {
  components: {
    KeyUnit
  },

  model: {
    prop: "inputValue",
    event: "onChanged",
  },

  props: {
    title: String,
    inputValue: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      value: undefined,
    };
  },

  created() {
    this.value = this.inputValue;
  },

  watch: {
    inputValue(value) {
      this.value = value;
    },

    value(value) {
      this.$emit("onChanged", value);
    },
  },
};
</script>
